module.exports = __webpack_public_path__ + "static/img/bin.0e5a88ea.png";